import React from 'react';
import { Box, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { useTileDimensions } from './hooks/useTileDimensions';

interface MainPhotoDropZoneProps {
  isVisible: boolean;
  isShowDescriptions: boolean;
}
export const MainPhotoDropZone: React.FC<MainPhotoDropZoneProps> = ({
  isVisible,
  isShowDescriptions,
}) => {
  const { tileHeight, tileWidth, tileMarginX, tileMarginY } =
    useTileDimensions(isShowDescriptions);

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        width: tileWidth,
        maxWidth: tileWidth,
        height: `${tileHeight}px`,
        border: 'dashed 3px',
        borderColor: 'states.focus',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.secondary', // Light blue background like upload area
        gap: 1,
        zIndex: 1,
        pointerEvents: 'none',
        mx: `${tileMarginX}px`,
        my: `${tileMarginY}px`,
      }}
    >
      <ImageIcon
        sx={{
          fontSize: '114px',
          width: '114px',
          height: '114px',
          color: 'secondary.medium',
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          color: 'secondary.medium',
          fontWeight: 500,
          fontSize: '21px',
          lineHeight: '28px',
          textAlign: 'center',
          width: '200px',
          px: 2,
        }}
      >
        Drag and Drop Main Photo here
      </Typography>
    </Box>
  );
};
